import Deviations from './Deviations';

export default Deviations;
